import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ShopItemType } from '../../../../../types/shop';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import ShopGrid from '../ShopGrid';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
}

const enhance = compose(withSectionFetchSpinner, withTranslation());
export class ShopPremiumContent extends React.Component<
  Props & WithTranslation
> {
  render() {
    const { t, className } = this.props;

    return (
      <div className={s['section-with-no-header']}>
        <ShopGrid
          className={className}
          itemType={ShopItemType.PREMIUM_CONTENT}
          duperbrowseTitle={t('common.shop')}
        />
      </div>
    );
  }
}

export default enhance(ShopPremiumContent) as React.ComponentType<Props>;
